module.exports = __webpack_public_path__ + "static/media/logo-540x360.af2ab33c.jpg";